




















import {
  Modal,
  ModalMixin,
  ImageCropper,
  AsyncBtn,
  notify,
} from 'mycorems-app-shared';
import { uploadLogo } from '..';

interface Data {
  logo: File|null,
  task: Promise<string>|null,
}

export default ModalMixin.extend({
  components: { Modal, ImageCropper, AsyncBtn },
  props: {
    accountId: {
      type: String,
      required: true,
    },
    logoUrl: String,
  },
  data(): Data {
    return {
      logo: null,
      task: null,
    };
  },
  methods: {
    upload() {
      if (this.logo) {
        this.task = uploadLogo(this.accountId, this.logo);
        this.task.then((logoUrl) => {
          this.$emit('ok', logoUrl);
          notify.success('Account logo uploaded.');
          this.hide();
        });
      }
    },
  },
});
